import { fromAccountId } from './accountId/accountId';
import * as constants from './constants';
import { rujiAssetId, tcyAssetId } from './constants';
const mayaTokenAssetId = 'cosmos:mayachain-mainnet-v1/slip44:maya';
export const accountIdToChainId = (accountId) => fromAccountId(accountId).chainId;
export const accountIdToSpecifier = (accountId) => fromAccountId(accountId).account;
export const isValidChainPartsPair = (chainNamespace, chainReference) => constants.VALID_CHAIN_IDS[chainNamespace]?.includes(chainReference) || false;
export const generateAssetIdFromCosmosSdkDenom = (denom) => {
    switch (denom) {
        case 'tcy':
            return tcyAssetId;
        case 'x/ruji':
            return rujiAssetId;
        case 'maya':
            return mayaTokenAssetId;
        default:
            throw new Error(`Unsupported denom: ${denom}`);
    }
};
export const bitcoinAssetMap = { [constants.btcAssetId]: 'bitcoin' };
export const bitcoinCashAssetMap = { [constants.bchAssetId]: 'bitcoin-cash' };
export const dogecoinAssetMap = { [constants.dogeAssetId]: 'dogecoin' };
export const litecoinAssetMap = { [constants.ltcAssetId]: 'litecoin' };
export const cosmosAssetMap = { [constants.cosmosAssetId]: 'cosmos' };
export const thorchainAssetMap = { [constants.thorchainAssetId]: 'thorchain' };
export const mayachainAssetMap = { [constants.mayachainAssetId]: 'cacao' };
